import React from 'react';
import { Grid } from '@mui/material';
import CustomCircleProfilePic from './CustomCircleProfilePic';
import EmployeeFullName from './EmployeeFullName';
import EmployeeDesignation from './EmployeeDesignation';
import './UserProfile.css';
import ReporterType from '../../infra/aggregates/reportsToInterface';

interface eventList {
  reporter: ReporterType;
  isDashboard?: boolean;
}

const UserProfilePresenter = ({ reporter, isDashboard }: eventList) => {
  return (
    <Grid
      container
      style={{
        height: '18em',
      }}
    >
      <Grid item xs={12} className="pic-box">
        <CustomCircleProfilePic
          profilePic={{
            pic: reporter.emp_pic,
            award: reporter.manager_award ? reporter.manager_award : '',
          }}
        />
      </Grid>
      <Grid item xs={12} className="name-box">
        <EmployeeFullName
          first_name={reporter.emp_name}
          last_name={''}
          isDashboard={isDashboard}
        />
      </Grid>
      <Grid item xs={12} className="designation-box">
        <EmployeeDesignation
          designation={reporter.emp_designation}
          isDashboard={isDashboard}
        />
      </Grid>
    </Grid>
  );
};
export default UserProfilePresenter;
